import React from 'react';
import { InboxDetails } from 'src/features/Inbox/components/templates/InboxDetails';
import { InboxDetailsContextProvider } from 'src/features/Inbox/contexts/InboxDetailsContext/InboxDetailsContextProvider';

export const InboxDetailsPage: React.FC = () => {
  return (
    <InboxDetailsContextProvider>
      <InboxDetails />
    </InboxDetailsContextProvider>
  );
};
